<div class="container">
  <button *ngIf="backButton" class="left-cta" (click)="previousCount()">
    <span>{{ 'back' | i18next }}</span>
  </button>
  <button
    *ngIf="nextButton"
    class="right-cta"
    (click)="nextCount()"
    [disabled]="disabled || isLoading"
    [class.disabled]="disabled || isLoading"
  >
    @if (isEmptyFields) {
    <span>
      {{ 'skip-for-now' | i18next }}
    </span>
    } @else if (isLoading) {
    <span>
      {{ 'loading' | i18next }}
    </span>
    } @else if (currentPage == 'address-info'){
    <span>
      {{ 'confirm-pin-location-button' | i18next }}
    </span>
    } @else {
    <span>{{ 'next' | i18next }}</span>
    }
  </button>
</div>
